import { render, staticRenderFns } from "./WhFieldSelectPopup.vue?vue&type=template&id=20b4d712&scoped=true&"
import script from "./WhFieldSelectPopup.vue?vue&type=script&lang=js&"
export * from "./WhFieldSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./WhFieldSelectPopup.vue?vue&type=style&index=0&id=20b4d712&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4d712",
  null
  
)

export default component.exports